import { SensorOrSubSensorInfoByType } from '@components/cockpit/panels/monitoring/monitoring.types';
import DataSheetCard from '@components/common/layout/DataSheetCard';
import { useFlirCommand } from '@hooks/useFlirCommand';
import { useIntl } from 'react-intl';

import { SensorTypeEnum } from '@/types/sensor/sensors';

export default function FlirCommands(
  sensorOrSubSensorInfo: Readonly<SensorOrSubSensorInfoByType<SensorTypeEnum.FLIR>>,
) {
  const { formatMessage } = useIntl();

  const { setEmission, isLoading } = useFlirCommand(sensorOrSubSensorInfo);

  const handleClick = (action: 'startEmission' | 'stopEmission') => {
    switch (action) {
      case 'startEmission': {
        setEmission(true);
        return;
      }
      case 'stopEmission': {
        setEmission(false);
        return;
      }
    }
  };

  const emissionActions = [
    {
      action: 'startEmission',
      i18nKey: 'sensors.tab.commands.flir.emission.startEmission',
    },
    {
      action: 'stopEmission',
      i18nKey: 'sensors.tab.commands.flir.emission.stopEmission',
    },
  ] as const;

  return (
    <DataSheetCard
      actions={emissionActions}
      description={formatMessage({ id: 'sensors.tab.commands.flir.emission.emissionDescription' })}
      isLoading={isLoading}
      isDisabled={isLoading}
      onClick={handleClick}
    />
  );
}
